import React, { useState } from 'react';

import Confirm from 'components/shared/Modal/Confirm/Confirm';
import Popover from 'components/shared/Popovers/Popover/Popover';

const AddServiceActions = (params) => {
  const { data, context } = params;
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const options = [
    {
      label: 'Edit',
      onClick: () => context?.onEditRow?.(data),
      icon: 'edit-2-mono'
    },
    {
      label: 'Remove',
      onClick: () => setShowDeleteModal(true),
      icon: 'trash-mono'
    }
  ];

  const handleRemove = () => {
    context?.onRemove?.(data.code);
    setShowDeleteModal(false);
  };

  return (
    <div className="flex h-full items-center justify-center">
      <Popover
        isFixed
        options={options}
        position="left"
        icon="context-menu-horizontal"
        className="flex flex-1 justify-center self-center"
      />
      {showDeleteModal && (
        <Confirm
          variant="danger"
          title="Remove service"
          icon="trash-mono"
          message="Are you sure you want to remove this service from the list?"
          handleOpen={showDeleteModal}
          handleClose={() => setShowDeleteModal(false)}
          footerActions={{
            primary: {
              text: 'Remove service',
              onClick: handleRemove,
              color: 'danger'
            }
          }}
        />
      )}
    </div>
  );
};

export default AddServiceActions;
